import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "monthSelector"
};
const _hoisted_2 = ["data-slot-key", "onClick"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MonthSelector',
    props: {
        slots: {},
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const selectedSlotKey = computed({
            get() {
                return props.modelValue ?? null;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        function onSlideGroupUpdate(newValue) {
            if (newValue && newValue !== selectedSlotKey.value) {
                selectedSlotKey.value = newValue;
            }
        }
        function onSlideGroupTouchEnd() {
            setTimeout(() => {
                updateSelectedFromCentre();
            }, 100);
        }
        function updateSelectedFromCentre() {
            const slideGroup = document.querySelector('.monthSlider');
            if (!slideGroup)
                return;
            const container = slideGroup.querySelector('.v-slide-group__container');
            if (!container)
                return;
            const items = container.querySelectorAll('span[data-slot-key]');
            const monthItems = Array.from(items).filter(item => {
                const text = item.textContent?.trim();
                return text && text.length > 0 && text !== '';
            });
            if (monthItems.length > 0) {
                findClosestItem(monthItems, container);
            }
        }
        function findClosestItem(items, container) {
            let closestItem = null;
            let closestDistance = Infinity;
            items.forEach((item) => {
                const itemRect = item.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                const itemCenter = itemRect.left - containerRect.left + itemRect.width / 2;
                const containerCenter = containerRect.width / 2;
                const distance = Math.abs(itemCenter - containerCenter);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestItem = item;
                }
            });
            if (closestItem) {
                const itemValue = closestItem.getAttribute('data-slot-key');
                const matchingSlot = props.slots.find(slot => slot.key === itemValue);
                if (matchingSlot) {
                    if (matchingSlot.key !== selectedSlotKey.value) {
                        selectedSlotKey.value = matchingSlot.key;
                    }
                    snapToCenter(closestItem, container);
                }
                else {
                    console.log('No matching slot found for:', itemValue);
                }
            }
        }
        function snapToCenter(selectedItem, container) {
            if (!selectedItem || !container)
                return;
            const itemRect = selectedItem.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const itemCenter = itemRect.left - containerRect.left + itemRect.width / 2;
            const containerCenter = containerRect.width / 2;
            const scrollOffset = itemCenter - containerCenter;
            container.scrollTo({
                left: container.scrollLeft + scrollOffset,
                behavior: 'smooth'
            });
        }
        return (_ctx, _cache) => {
            const _component_v_slide_group_item = _resolveComponent("v-slide-group-item");
            const _component_v_slide_group = _resolveComponent("v-slide-group");
            return (selectedSlotKey.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_slide_group, {
                        ref: "monthSlideGroup",
                        "center-active": true,
                        class: "monthSlider",
                        modelValue: selectedSlotKey.value,
                        "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event) => ((selectedSlotKey).value = $event)),
                            onSlideGroupUpdate
                        ],
                        onTouchend: onSlideGroupTouchEnd
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_slide_group_item, null, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createElementVNode("span", null, null, -1)
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_slide_group_item, null, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createElementVNode("span", null, null, -1)
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_slide_group_item, null, {
                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createElementVNode("span", null, null, -1)
                                ])),
                                _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slots, (s) => {
                                return (_openBlock(), _createBlock(_component_v_slide_group_item, {
                                    value: s.key,
                                    key: s.key
                                }, {
                                    default: _withCtx(({ isSelected, toggle }) => [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(isSelected ? 'selected' : ''),
                                            "data-slot-key": s.key,
                                            onClick: ($event) => { toggle(); selectedSlotKey.value = s.key; }
                                        }, _toDisplayString(s.label), 11, _hoisted_2)
                                    ]),
                                    _: 2
                                }, 1032, ["value"]));
                            }), 128)),
                            _createVNode(_component_v_slide_group_item, null, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createElementVNode("span", null, null, -1)
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_slide_group_item, null, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                    _createElementVNode("span", null, null, -1)
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_slide_group_item, null, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createElementVNode("span", null, null, -1)
                                ])),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"]),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "centerDot" }, null, -1))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
